import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const productInfoApi = createApi({
  reducerPath: "productInfo",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["ProductInfo"],
  keepUnusedDataFor: 300,
  endpoints(builder) {
    return {
      deleteProductInfo: builder.mutation({
        query: (input) => {
          return apiFunction(
            input,
            "/api/productInfoes/storageRoles/delete-product-info",
            "DELETE"
          );
        },
        invalidatesTags: ["ProductInfo"],
      }),
      addProductInfo: builder.mutation({
        query: (input) => {
          return apiFunction(
            input,
            "/api/productInfoes/storageRoles/create-product-info",
            "POST"
          );
        },
        invalidatesTags: ["ProductInfo"],
      }),
      updateProductInfo: builder.mutation({
        query: (input) => {
          return apiFunction(
            input,
            "/api/productInfoes/storageRoles/update-product-info",
            "PATCH"
          );
        },
        invalidatesTags: ["ProductInfo"],
      }),
      fetchProductInfo: builder.query({
        query: (token) => {
          return apiFunction(
            { token },
            "/api/productInfoes/storageRoles/get-all-product-infoes",
            "POST"
          );
        },
        providesTags: ["ProductInfo"],
      }),
    };
  },
});

export const {
  useFetchProductInfoQuery,
  useAddProductInfoMutation,
  useUpdateProductInfoMutation,
  useDeleteProductInfoMutation,
} = productInfoApi;

export { productInfoApi };
